<div class="row mt-3 mx-1 mb-4 ">
    <div class="col-lg-12 ml-3 text-right">
        <button class="btn blue-btn btn-sm" data-bs-toggle="modal" [disabled]="global.viewTabs || global.viewEmployeeTabs"
            data-bs-target="#modalRelationship" 
            (click)="GetAllTaxes()" *ngIf="fpclient.releationshipcreate &&  CERelation.RelationshipType == 'Client'">Add
            Relationship</button>
            <button class="btn blue-btn btn-sm" data-bs-toggle="modal" [disabled]="global.viewTabs || global.viewEmployeeTabs"
            data-bs-target="#modalRelationship" 
            (click)="GetAllTaxes()" *ngIf="fpemployee.employeerelationshipcreate && CERelation.RelationshipType == 'Employee'">Add
            Relationship</button>
    </div>
</div>
<div class="row mt-1 mx-1">
    <div class="col-lg-4">
        <div class="row" *ngIf="CERelation.RelationshipType == 'Employee'">
            <div class="col-lg-4">
                <span>Client&nbsp;</span>
            </div>
            <div class="col-lg-8">
                <ng-select class="w-100" [(ngModel)]="RelationShipFilterBo.clientId" (change)="getFilter()"
                    style="color: black;" [clearable]="true" [searchable]="true" [items]="ClientDropdown"
                    bindLabel="Value" bindValue="Key" [disabled]="global.viewTabs || global.viewEmployeeTabs">
                </ng-select>
            </div>
        </div>
        <div class="row" *ngIf="CERelation.RelationshipType == 'Client'">
            <div class="col-lg-4">
                <span>Employee &nbsp;</span>
            </div>
            <div class="col-lg-9">
                <ng-select class="w-100" [(ngModel)]="RelationShipFilterBo.employeeId" (change)="getFilter()"
                    style="color: black;" [clearable]="true" [searchable]="true" [items]="EmployeeDropdown"
                    bindLabel="Value" bindValue="Key" [disabled]="global.viewTabs || global.viewEmployeeTabs">
                </ng-select>
            </div>
        </div>
    </div>

    <div class="col-lg-4">
        <div class="row">
            <div class="col-lg-4">
                <span>Relationship &nbsp;</span>
            </div>
            <div class="col-lg-8">
                <ng-select class="w-100" [(ngModel)]="RelationShipFilterBo.relationshipId" (change)="getFilter()"
                    style="color: black;" [clearable]="true" [searchable]="true" [items]="RelationshipDropdown"
                    bindLabel="Value" bindValue="Key" [disabled]="global.viewTabs || global.viewEmployeeTabs">
                </ng-select>
            </div>
        </div>
    </div>
    <div class="col-lg-4">
        <div class="row">
            <div class="col-lg-4">
                <span>Status &nbsp;</span>
            </div>
            <div class="col-lg-8">
                <ng-select class="w-100" [(ngModel)]="RelationShipFilterBo.statusLid" (change)="getFilter()"
                    style="color: black;" [clearable]="true" [searchable]="true" [items]="AllRelationshipStatusList"
                    bindLabel="lovName" bindValue="id" [disabled]="global.viewTabs || global.viewEmployeeTabs">
                </ng-select>
            </div>
        </div>
    </div>
</div>

<div class="row mb-2 mt-4">
    <div class="col mt-1">
        <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pt-2">
                <ejs-grid #gridRelationship [dataSource]='GridData | async' [allowPaging]='true'
                    [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
                    [allowResizing]='true' (dataStateChange)='dataChangeRelationship($event)' [showColumnChooser]='true'
                    (actionBegin)="onActionRelationship($event)" [allowSorting]='true'>
                    <e-columns>
                        <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                            <ng-template #template let-data>
                                <button class="btn btn-edit-table" data-bs-toggle="modal"
                                    data-bs-target="#modalRelationship" 
                                    [disabled]="global.viewTabs || global.viewEmployeeTabs" (click)="getDetails(data)" *ngIf="fpclient.releationshipcreate && CERelation.RelationshipType == 'Client'"><i
                                        class="fa fa-edit"></i></button>&nbsp;
                                        <button class="btn btn-edit-table" data-bs-toggle="modal"
                                    data-bs-target="#modalRelationship" 
                                    [disabled]="global.viewTabs || global.viewEmployeeTabs" (click)="getDetails(data)"  *ngIf="fpemployee.employeerelationshipupdate && CERelation.RelationshipType == 'Employee'"><i
                                        class="fa fa-edit" ></i></button>&nbsp;

                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 *ngIf="CERelation.RelationshipType == 'Employee'" field="clientName"
                            headerText="Client Name" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>

                        <e-column minWidth=100 *ngIf="CERelation.RelationshipType == 'Client'" field="employeeName"
                            headerText="Employee Name" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>

                        <e-column minWidth=100 field="relationshipName" headerText="Relationship Name" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="statusName" headerText="Status" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>

                        <e-column width="50"   [showInColumnChooser]='false'>
                            <ng-template #headerTemplate let-data>
                                <div>
                                    <span id='show' (click)='showRelationshipColumns()'><i class="fa fa-cog fa-lg"
                                            aria-hidden="true">
                                        </i></span>
                                </div>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</div>


<span id="openRelationshipModal" data-bs-toggle="modal" data-bs-target="#modalRelationship"></span>
<div class="modal fade" id="modalRelationship" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span
                        *ngIf="saveRelationshipInfo.id == '00000000-0000-0000-0000-000000000000'">
                        Create
                        Relationship</span>
                    <span *ngIf="saveRelationshipInfo.id != '00000000-0000-0000-0000-000000000000'">Update
                        Relationship</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="clearRelationalship()">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">

                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Status<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <ng-select [items]="RelationshipStatusList" class="width25" [searchable]="true"
                            [clearable]="false" bindLabel="lovName" bindValue="id"
                            [(ngModel)]="saveRelationshipInfo.statusLid">
                        </ng-select>
                    </div>
                </div>
                <!-- Client -->
                <div class="row mt-1" *ngIf="CERelation.RelationshipType == 'Employee'">
                    <div class="col-lg-5">
                        <label>Client<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <ng-select class="width25" [searchable]="true" [items]="ClientDropdown" [clearable]="true"
                            bindLabel="Value" bindValue="Key" [(ngModel)]="saveRelationshipInfo.clientId">
                        </ng-select>
                    </div>
                </div>
                <!-- Employee -->
                <div class="row mt-1" *ngIf="CERelation.RelationshipType == 'Client'">
                    <div class="col-lg-5">
                        <label>Employee<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <ng-select class="width25" [items]="EmployeeDropdown" [searchable]="true" [clearable]="true"
                            bindLabel="Value" bindValue="Key" [(ngModel)]="saveRelationshipInfo.employeeId">
                        </ng-select>
                    </div>
                </div>
                <!-- Relationship -->
                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Relationship<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <ng-select class="width25" [items]="RelationshipDropdown" [searchable]="true" [clearable]="true"
                            bindLabel="Value" bindValue="Key" [(ngModel)]="saveRelationshipInfo.relationshipId">
                        </ng-select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-lg-5">
                        <label>LiveIn
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="checkbox" [(ngModel)]="saveRelationshipInfo.living">
                    </div>
                </div>
                <div class="table-responsive mt-3">
                    <table class="table  table-hover " style="margin-top: 3px;">
                        <tr style=" background-color:  #00786a !important;height: 32px">
                            <th scope="col" style="color:white;background-color:  #00786a !important"
                                class="pointer text-center">
                                Tax Name</th>
                            <th scope="col" style="color:white" class="pointer text-center ">
                                Taxable
                            </th>
                        </tr>
                        <tbody *ngFor="let RT of saveRelationshipInfo.relationshipTaxes">
                            <tr>
                                <td class="text-center">
                                    {{RT.taxName}}
                                </td>
                                <td class="text-center">
                                    <input type="checkbox" [(ngModel)]="RT.taxable">
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
            <div class="modal-footer">
                <button *ngIf="CERelation.RelationshipType == 'Client'" class="btn  btn-sm"
                    (click)="SaveOrUpdateRelationship();" [disabled]="saveRelationshipInfo.relationshipId==null||
                    saveRelationshipInfo.relationshipId==undefined || saveRelationshipInfo.relationshipId==''||
                    saveRelationshipInfo.employeeId==null || saveRelationshipInfo.employeeId==undefined ||
                    saveRelationshipInfo.employeeId=='' "><span
                        *ngIf="saveRelationshipInfo.id == '00000000-0000-0000-0000-000000000000'"> Save &
                        Close</span> <span
                        *ngIf="saveRelationshipInfo.id != '00000000-0000-0000-0000-000000000000'">Update & Close</span>
                </button>
                <button *ngIf="CERelation.RelationshipType == 'Employee'" class="btn  btn-sm"
                    (click)="SaveOrUpdateRelationship();" [disabled]="saveRelationshipInfo.relationshipId==null||
                    saveRelationshipInfo.relationshipId==undefined || saveRelationshipInfo.relationshipId==''||
                    saveRelationshipInfo.clientId==null || saveRelationshipInfo.clientId==undefined ||
                    saveRelationshipInfo.clientId=='' "><span
                        *ngIf="saveRelationshipInfo.id == '00000000-0000-0000-0000-000000000000'"> Save &
                        Close</span> <span
                        *ngIf="saveRelationshipInfo.id != '00000000-0000-0000-0000-000000000000'">Update & Close</span>
                </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                    (click)="clearRelationalship()">Cancel</button>
            </div>
        </div>
    </div>
</div>

  
   
